import React, { Component } from 'react';
import { withRouter } from 'react-router';

import LatestJobs from '../applicant/home-jobs';
import AddToList from '../applicant/add-to-list/add-to-list.component';
import YourBiographies from '../applicant/home-biographies';

import CompanyMembers from '../company/company-members/company-members.component';
import FindCandidate from '../company/find-candidate/find-candidate.component';
import LatestBiographies from '../company/latest-biographies/latest-biographies.component';
import YourJobs from '../company/home-jobs';
import ProfileStrength from '../company/company-profile/company-profile-strength.component';

import RecommendedArticles from '../recommended-articles/recommended-articles.component';
import ExplorePremium from '../company/explore-premium/explore-premium-component';
// styles
import {  Container , Row , Col  } from 'react-bootstrap';

class  Homepage extends Component{

    userType = JSON.parse(localStorage.getItem('jwt')).user.typeName;
    render(){
        if(this.userType){
            if(this.userType === 'Applicant'){
                return(
                <div>
                        <Container>
                            <Row>
                                <Col className="p-0" md={12}>
                                    <YourBiographies/>
                                    <LatestJobs/>
                                </Col>
                                {/* <Col className="p-0 pt-4" md={4}>
                                    <Container fluid>
                                        <AddToList/>
                                        <RecommendedArticles/>
                                    </Container>
                                </Col> */}
                            </Row>
                        </Container>
                    </div>
                );
            }
            else {
                return(
                    <div>
                    <Container>
                        <Row>
                            <Col className="p-0" md={12}>
                                <YourJobs/>
                                {/* <LatestBiographies/> */}
                                {/* <FindCandidate/> */}
                            </Col>
                            {/* <Col className="p-0" md={4}>
                                <Container fluid>
                                    <ProfileStrength />
                                    <ExplorePremium/>
                                    <CompanyMembers/>
                                    <RecommendedArticles/>
                                </Container>
                            </Col> */}
                        </Row>
                    </Container>
                    </div>
                );
            } 
    }
    else{
        return(<div>error</div>)
    }
    }
}

export default withRouter(Homepage);